import styled from "styled-components";
import { Card } from "react-bootstrap";

export const StyledCard = styled(Card)`
  position: relative;
  width: 180px;
  height: 230px;
  background: #f8fcff;
  border: 0.5px solid var(--primary-color);
  box-shadow: 1px 8px 10px 2px rgba(87, 103, 191, 0.1);
  border-radius: 12px;
  .active-btn {
    background: #495dca;
    color: var(--white-color);
    border-radius: 8px;
    border: none;
    width: 160px;
    height: 40px;
    font-weight: 500;
    font-size: var(--font-size-sm);
  }
  .disactive-btn {
    border-radius: 8px;
    border: none;
    width: 160px;
    height: 40px;
    background: #a4adbc;
    color: var(--white-color);
    font-size: var(--font-size-sm);
  }
`;
export const Title = styled.h3`
  font-weight: 500;
  font-size: var(--font-size-sm);
  color: var(--blue-color-dark);
`;
export const StyledDiscountLabel = styled.span`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 50px;
  height: 20px;
  padding: 2px;
  background: var(--secondary-color);
  text-align: center;
  font-size: var(--font-size-xs);
  font-weight: 700;
  color: #142b43;
`;
export const AfterDiscount = styled.span`
  font-size: var(--font-size-md);
  color: var(--primary-color);
`;
export const BeforeDiscount = styled.span`
  font-weight: 500;
  font-size: var(--font-size-xs);
  color: var(--dark-color);
  text-decoration: line-through;
  text-decoration-color: var(--danger-color);
`;
export const CurrencyPrice = styled.span`
  font-weight: 300;
  font-size: var(--font-size-xs);
  color: var(--text-color-dark);
`;
